import React, { useLayoutEffect } from 'react'
import { useDispatch } from '@/store'
import { setAdminTicket } from '@/store/authSlice'
import { getUrlParam } from '@/utils'
import { multiAccountLoginCheck } from '@/utils/multiAccountLoginCheck'
import Cookies from 'js-cookie'

/** 超管登录设置ticket */
export const withSuperManager = <P extends Record<string, any>>(Component: React.FC<P>) => {
  const SuperManager: React.FC<P> = (props) => {
    const dispatch = useDispatch()

    useLayoutEffect(() => {
      const ticket = getUrlParam('adminTicket') || Cookies.get('authorization')
      if (ticket) {
        multiAccountLoginCheck()
        dispatch(setAdminTicket(ticket))
        Cookies.set('authorization', ticket)
      }
    }, [dispatch])

    return <Component {...props} />
  }

  SuperManager.displayName = 'SuperManager'
  return SuperManager
}
